import React from 'react';
import {
  TextField,
  useGetIdentity,
  DateField,
  FunctionField,
  ImageField,
} from 'react-admin';
import { usePageTitle } from '../../../components/usePageTitle';
import CustomizableDatagrid from '../../../utils/libs/CustomizableDatagridLib';
import { CUSTOM_STORAGE } from '../../../constants/list-column-custom-storage';
import { ShowIdButton } from '../../../components/ShowIdButton';
import { TRASACTION_STATUSE } from '../../../constants/statuses';

const DEFAULT_COLUMNS = ['id', 'status'];

const TransactionList = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();
  if (identityLoading) {
    return null;
  }

  return (
    <CustomizableDatagrid
      storage={CUSTOM_STORAGE}
      defaultColumns={DEFAULT_COLUMNS}
    >
      <ShowIdButton source="id" />
      <TextField sortable={false} source="amount_total" label="Total amount" />
      <TextField
        sortable={false}
        source="user_account_id"
        label="User account ID"
      />
      <TextField sortable={false} source="user_id" label="User ID" />
      <FunctionField
        label="Status"
        render={({ status }) => <span>{TRASACTION_STATUSE[status]}</span>}
      />
      <TextField sortable={false} source="type" label="Type" />
      <TextField sortable={false} source="account_iban" label="Account IBAN" />
      <TextField
        sortable={false}
        source="target_card_id"
        label="Target card ID"
      />
      <TextField sortable={false} source="card_id" label="Card ID" />
      <TextField sortable={false} source="card_mask" label="Card mask" />
      <TextField
        sortable={false}
        source="card_description"
        label="Card daescription"
      />
      <TextField sortable={false} source="currency_id" label="Currency ID" />
      <TextField sortable={false} source="tax" label="Tax" />
      <TextField sortable={false} source="amount" label="Amount" />
      <TextField
        sortable={false}
        source="penalty_amount"
        label="Penalty amount"
      />
      <TextField
        sortable={false}
        source="amount_default"
        label="Default amount"
      />
      <TextField sortable={false} source="old_balance" label="Old balance" />
      <TextField sortable={false} source="new_balance" label="New baalance" />
      <TextField sortable={false} source="description" label="Description" />
      <TextField sortable={false} source="comment" label="Comment" />
      <FunctionField
        sortable={false}
        source="merchant"
        label="Merchant"
        render={() => (
          <div className="logoWrapper">
            <ImageField source="merchant.file" />
            <TextField source="merchant.name" />
          </div>
        )}
      />
      <TextField sortable={false} source="type_enum" label="Type enum" />
      <TextField sortable={false} source="country" label="Country" />
      <TextField sortable={false} source="status_text" label="Status text" />
      <TextField
        sortable={false}
        source="custom_status"
        label="Custom status"
      />
      <TextField
        sortable={false}
        source="money_request_id"
        label="Money request id"
      />
      <TextField
        sortable={false}
        source="amount_original"
        label="Amount original"
      />
      <TextField
        sortable={false}
        source="currency_code_original"
        label="Currency code original"
      />
      <DateField sortable={false} source="created_at" />
      <DateField sortable={false} source="processed_at" />
    </CustomizableDatagrid>
  );
};
export default TransactionList;
